export default __webpack_public_path__ + "static/media/218.75ba2cfc.gif";